import { formatDateTime } from '@/util/date';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

/**
 * Mengekspor data koordinat ke file Excel.
 * @param {object} mappedData - Objek yang berisi tableData, totalDistance, dan totalDuration.
 * @param {string} unit - Unit yang sedang aktif ('NM - KNOTS' atau 'KM - KM/H').
 */
// eslint-disable-next-line import/prefer-default-export
export async function exportCoordinates(mappedData, unit) {
  try {
    const isNautical = unit === 'NM - KNOTS';
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Coordinates');

    // Header
    worksheet.addRow([
      'From',
      'To',
      'Heading',
      `Speed (${isNautical ? 'KNOTS' : 'KM/H'})`,
      'ETA',
      `Distance (${isNautical ? 'NM' : 'KM'})`,
      'Duration',
    ]);

    // Data
    mappedData.tableData.forEach((item) => {
      worksheet.addRow([
        `${item?.from?.lat} ${item?.from?.lng}`,
        `${item?.to?.lat} ${item?.to?.lng}`,
        item?.heading,
        item?.speed,
        item?.eta,
        item?.distance,
        item?.duration,
      ]);
    });

    worksheet.addRow([]); // Baris kosong

    // Total
    const totalRow = worksheet.addRow([
      '', '', '', '', 'Total',
      mappedData.totalDistance,
      mappedData.totalDuration,
    ]);
    totalRow.font = { bold: true };

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    const filename = `${formatDateTime(new Date(), 'YYYYMMDD_HHmmss', null, false)}-coordinates`;
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${filename}.xlsx`);
  } catch (e) {
    console.error('Error exporting coordinates to Excel:', e);
    // Melempar kembali error agar bisa ditangani di komponen jika perlu
    throw e;
  }
}
